module.exports = __webpack_public_path__ + "public/img/pet_default.2579a82e.svg";